import React, { Component } from "react";
import Footer from "./../../Layout/Footer2";
import Header from "./../../Layout/Header";
import { Helmet } from 'react-helmet';
import api from './../Api';
import { Link } from "react-router-dom";
import ContentJobs from './../../Element/ContentJobs';
// import Jobfindbox from "./../../Element/Jobfindbox2";

const axios = require('axios');

class JobsFromRemoteOk extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobs: [],
            total: '',
            isLoading: true
        };
    }

    componentDidMount() {
        this.getJobs();
    }

    getJobs() {
        axios
            .request(api.getJobs('', '', 'remoteok'))
            .then((response) => {
                this.setState({
                    jobs: response.data.jobs,
                    total: response.data.pagesInfo.totalJobs,
                    pages: response.data.pagesInfo.totalpages,
                    page: response.data.pagesInfo.page,
                    perPage: response.data.pagesInfo.perPage,
                    prevPage: response.data.pagesInfo.prevPage,
                    nextPage: response.data.pagesInfo.nextPage,
                    isLoading: false
                });
            })
            .catch((error) => {
                console.error(error);
                this.setState({ isLoading: false });
            });
    }

    render() {
        let { jobs, total, page, pages, prevPage, nextPage, isLoading } = this.state;

        return (
            <div className="page-wraper">
                <Header />

                <Helmet>
                    <title>Jobs from RemoteOK: Find your job here on #OpenToWorkRemote!</title>
                    <meta name="description" content="Looking for jobs from RemoteOK? Find your dream job here and apply today!" />
                    <link rel="canonical" href="https://www.opentoworkremote.com/jobs-from-remoteok" />
                </Helmet>

                <div className="page-content bg-white">
                    <div className="dez-bnr-inr bg-dark">
                        <div className="container">
                            <div className="dez-bnr-inr-entry">
                                <Link to={""}>
                                    <h1 className="text-white">
                                        Find jobs from RemoteOK
                                    </h1>
                                </Link>
                                <div className="source-info mt-3">
                                    <p className="text-white mb-2">
                                        RemoteOK is a leading platform for remote job opportunities.
                                    </p>
                                    <h6 className="text-white">
                                        <a href="https://remoteok.com/?ref=opentoworkremote.com&utm_source=opentoworkremote.com" target="_blank" rel="noopener noreferrer" className="text-white">
                                            Visit RemoteOK <i className="fa fa-external-link"></i>
                                        </a>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-5" />

                    <ContentJobs
                        jobs={jobs}
                        total={total}
                        page={page}
                        pages={pages}
                        prevPage={prevPage}
                        nextPage={nextPage}
                        isLoading={isLoading}
                    />
                </div>

                <Footer />
            </div>
        );
    }
}

export default JobsFromRemoteOk;
